import { useEffect, useState } from "react";
import { History, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useApp } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import { fingerprint } from "@/lib/resumableUpload";

export const PendingUploads = ({ file, busy }) => {
  const { L } = useApp();
  const { workspace } = useAuth();
  const [items, setItems] = useState([]);
  const [fp, setFp] = useState(null);
  useEffect(() => { setFp(null); if (file) fingerprint(file).then(setFp); }, [file]);
  const load = () => workspace && api.get("/uploads/pending", { params: { workspace_id: workspace.id } }).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { if (!busy) load(); }, [workspace, busy]); // eslint-disable-line react-hooks/exhaustive-deps
  const shown = items.filter((u) => u.source === "upload");
  if (!shown.length || busy) return null;
  const discard = async (id) => { await api.delete(`/uploads/${id}`).catch(() => {}); load(); };
  return (
    <div className="mt-6 space-y-2" data-testid="pending-uploads">
      {shown.map((u) => {
        const pct = Math.round((Math.min(u.received.length * u.chunk_size, u.size) / u.size) * 100);
        const match = file && fp && (fp === u.fingerprint || u.fingerprint.startsWith(`${fp}-c`));
        return (
          <div key={u.id} className={`flex flex-wrap items-center gap-3 rounded-2xl border p-4 text-sm ${match ? "border-emerald-300 bg-emerald-50" : "border-amber-200 bg-amber-50"}`} data-testid={`pending-upload-${u.id}`}>
            <History size={18} className={match ? "text-emerald-600" : "text-amber-600"} />
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-slate-900">{L("Muat naik belum selesai", "Unfinished upload")}: <span className="font-mono">{u.filename}</span> ({pct}%)</p>
              <p className="text-xs text-slate-600">{match ? L(`Fail sepadan — klik "Muat naik & proses" untuk sambung dari ${pct}%.`, `File matches — click "Upload & process" to resume from ${pct}%.`) : L("Pilih fail yang sama di bawah untuk sambung dari tempat ia berhenti. Disimpan 24 jam.", "Pick the same file below to resume where it stopped. Kept for 24 hours.")}</p>
            </div>
            <Button size="sm" variant="ghost" className="text-red-600" onClick={() => discard(u.id)} data-testid={`pending-upload-discard-${u.id}`}><Trash2 size={14} className="mr-1" />{L("Buang", "Discard")}</Button>
          </div>
        );
      })}
    </div>
  );
};
